import React from 'react';

type Props = {
  width?: number;
  height?: number;
};

export const SearchIcon: React.FC<Props> = ({ width = 17.66, height = 17.7 }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 17.66 17.7">
      <g id="Layer_17" data-name="Layer 17" transform="translate(-3.159 -3.2)">
        <path
          id="search"
          d="M20.6,19.6l-3.8-3.8a7.7,7.7,0,1,0-6,2.8,8,8,0,0,0,5-1.7l3.8,3.8.5.2.5-.2A.8.8,0,0,0,20.6,19.6Zm-16-8.7a6.3,6.3,0,1,1,6.2,6.2,6.3,6.3,0,0,1-6.2-6.2Z"
          fill="#2f353e"
        />
      </g>
    </svg>
  );
};
